// Generated by purs version 0.13.8
"use strict";
var $foreign = require("/usr/src/app/www/src/Lib/Packages/Gatsby/Image.js");
var React_Basic = require("/usr/src/app/www/.spago/react-basic/v15.0.0/src/React/Basic.purs");
var img = React_Basic.element($foreign.img_);
module.exports = {
    img: img
};
